var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#51A196",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.7,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.334 12.667A1.333 1.333 0 0 1 14 14H2a1.334 1.334 0 0 1-1.333-1.333V5.333A1.333 1.333 0 0 1 2 4h2.667L6 2h4l1.334 2H14a1.333 1.333 0 0 1 1.334 1.333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 11.333A2.667 2.667 0 1 0 8 6a2.667 2.667 0 0 0 0 5.333"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export { SvgCamera as ReactComponent };
export default __webpack_public_path__ + "assets/images/camera.svg";